import { Columns } from '@/components/table/types';
import styles from '../../game/member/style.module.styl';
import { ScopeInfo } from '@api/controll';
import { convertApiStatusText } from '@/views/controllCenter/util';
import { ApiInfoStatus } from '@/type/enums';
import ApplyPlc from '../plc/apply.vue';
import DetailPlc from '../plc/detail.vue';

export const columns: (detailSelfApiApply: Function) => Columns<ScopeInfo>[] = (
    detailSelfApiApply,
) => [
    {
        label: '权限包',
        width: '120px',
        prop: 'scopeGroupName',
    },
    {
        label: '介绍',
        align: 'center',
        prop: 'scopeGroupDesc',
    },
    {
        label: 'scope',
        width: '130px',
        align: 'center',
        render: ({ row }) =>
            row.scopeList.length ? (
                <div class="scope">
                    {row.scopeList.map((it) => (
                        <div key={it} class="scope-info">
                            {it}
                        </div>
                    ))}
                </div>
            ) : (
                <div class="scope">-</div>
            ),
    },
    {
        label: '状态',
        width: '120px',
        align: 'center',
        render: ({ row }) => (
            <span>
                {convertApiStatusText(row.status, row.extraOption) ||
                    row.rejectReason}
            </span>
        ),
    },
    {
        label: '操作',
        width: '120px',
        render: ({ row, $index }) => {
            const isPlc = row.extraOption === 'mpPlc';
            if (isPlc) {
                return row.status === ApiInfoStatus.notApply ? (
                    <ApplyPlc scopeGroupId={row.scopeGroupId}>
                        <a class={styles.method}>申请</a>
                    </ApplyPlc>
                ) : row.status === ApiInfoStatus.applied ? (
                    <DetailPlc scopeGroupId={row.scopeGroupId}>
                        <a class={styles.method}>查看详情</a>
                    </DetailPlc>
                ) : (
                    '-'
                );
            }

            return row.status === ApiInfoStatus.notApply ? (
                <a
                    class={styles.method}
                    onClick={() => detailSelfApiApply($index)}
                >
                    申请
                </a>
            ) : row.status === ApiInfoStatus.applyRefused ? (
                <a
                    class={styles.method}
                    onClick={() => detailSelfApiApply($index)}
                >
                    重新申请
                </a>
            ) : (
                '-'
            );
        },
    },
];
